import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

// Define interfaces for better type safety
interface OptionType {
  value: string;
  name?: string;
  major?: string;
  minor?: string;
  login?: string;
}


interface PageData {
  country: string;
  distributor4DigitCode: string;
  nowDate: string;
  states: OptionType[];
  familyBackgrounds: string[];
  salesmen: { name: string; login: string }[];
  leadCollectors: { name: string; login: string }[];
  telemarketers: { name: string; login: string }[];
  trainers: { name: string; login: string }[];
  typeOfSale: { major: string; minor: string }[];
  competencyOptions: { major: string; minor: string }[];
  yearLevels: { value: string; name: string }[];
  isNZ: boolean;
  errorMsg: string;
  showMessage: string;
}

interface FormData {
  // Family Information
  txtName: string;
  txtEntrySurname: string;
  txtMotherName: string;
  txtMotherSurname: string;
  rdoPrimaryContactFather: boolean;
  rdoPrimaryContactMother: boolean;
  ddlFamilyBackground: string;
  txtAddress: string;
  ddlEntryState: string;
  txtState: string;
  txtEntrySuburb: string;
  txtSuburb: string;
  txtEntryPostCode: string;
  txtPostCode: string;
  txtAreaCode: string;
  txtPhone: string;
  txtMobile: string;
  txtMobileNo2: string;
  txtEmail: string;

  // Sales Information
  calDateOfSale: string;
  ddlTypeOfSale: string;
  ddlSalesman: string;
  ddlLeadCollector: string;
  ddlTelemarketer: string;
  ddlTrainer: string;
  chbDongleVersion: boolean;
  chbWebVersion: boolean;
  txtOrderReferenceNo: string;
  txtSchool: string;

  // Student Information
  txtStudentname1: string;
  txtStudentLastName1: string;
  txtDateOfBirth1: string;
  rdoMale1: boolean;
  rdoFemale1: boolean;
  ddlYearLevel1: string;
  ddlCompetency1: string;
  txtEmail1: string;

  txtStudentname2: string;
  txtStudentLastName2: string;
  txtDateOfBirth2: string;
  rdoMale2: boolean;
  rdoFemale2: boolean;
  ddlYearLevel2: string;
  ddlCompetency2: string;
  txtEmail2: string;

  txtStudentname3: string;
  txtStudentLastName3: string;
  txtDateOfBirth3: string;
  rdoMale3: boolean;
  rdoFemale3: boolean;
  ddlYearLevel3: string;
  ddlCompetency3: string;
  txtEmail3: string;

  txtStudentname4: string;
  txtStudentLastName4: string;
  txtDateOfBirth4: string;
  rdoMale4: boolean;
  rdoFemale4: boolean;
  ddlYearLevel4: string;
  ddlCompetency4: string;
  txtEmail4: string;

  txtStudentname5: string;
  txtStudentLastName5: string;
  txtDateOfBirth5: string;
  rdoMale5: boolean;
  rdoFemale5: boolean;
  ddlYearLevel5: string;
  ddlCompetency5: string;
  txtEmail5: string;

  txtStudentname6: string;
  txtStudentLastName6: string;
  txtDateOfBirth6: string;
  rdoMale6: boolean;
  rdoFemale6: boolean;
  ddlYearLevel6: string;
  ddlCompetency6: string;
  txtEmail6: string;

  txtStudentname7: string;
  txtStudentLastName7: string;
  txtDateOfBirth7: string;
  rdoMale7: boolean;
  rdoFemale7: boolean;
  ddlYearLevel7: string;
  ddlCompetency7: string;
  txtEmail7: string;

  // Login Information
  txtLoginID: string;
  txtPassword: string;
}

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const EL_CheckCMS: React.FC = () => {
  const navigate = useNavigate();

  // Initialize form data with all fields
  const initialFormData: FormData = {
    // Family Information
    txtName: '',
    txtEntrySurname: '',
    txtMotherName: '',
    txtMotherSurname: '',
    rdoPrimaryContactFather: true,
    rdoPrimaryContactMother: false,
    ddlFamilyBackground: '',
    txtAddress: '',
    ddlEntryState: '',
    txtState: '',
    txtEntrySuburb: '',
    txtSuburb: '',
    txtEntryPostCode: '',
    txtPostCode: '',
    txtAreaCode: '',
    txtPhone: '',
    txtMobile: '',
    txtMobileNo2: '',
    txtEmail: '',

    // Sales Information
    calDateOfSale: new Date().toISOString().split('T')[0],
    ddlTypeOfSale: '3',
    ddlSalesman: '',
    ddlLeadCollector: '',
    ddlTelemarketer: '',
    ddlTrainer: '',
    chbDongleVersion: false,
    chbWebVersion: false,
    txtOrderReferenceNo: '',
    txtSchool: '',

    // Student Information
    txtStudentname1: '',
    txtStudentLastName1: '',
    txtDateOfBirth1: '',
    rdoMale1: true,
    rdoFemale1: false,
    ddlYearLevel1: '',
    ddlCompetency1: '',
    txtEmail1: '',

    txtStudentname2: '',
    txtStudentLastName2: '',
    txtDateOfBirth2: '',
    rdoMale2: true,
    rdoFemale2: false,
    ddlYearLevel2: '',
    ddlCompetency2: '',
    txtEmail2: '',

    txtStudentname3: '',
    txtStudentLastName3: '',
    txtDateOfBirth3: '',
    rdoMale3: true,
    rdoFemale3: false,
    ddlYearLevel3: '',
    ddlCompetency3: '',
    txtEmail3: '',

    txtStudentname4: '',
    txtStudentLastName4: '',
    txtDateOfBirth4: '',
    rdoMale4: true,
    rdoFemale4: false,
    ddlYearLevel4: '',
    ddlCompetency4: '',
    txtEmail4: '',

    txtStudentname5: '',
    txtStudentLastName5: '',
    txtDateOfBirth5: '',
    rdoMale5: true,
    rdoFemale5: false,
    ddlYearLevel5: '',
    ddlCompetency5: '',
    txtEmail5: '',

    txtStudentname6: '',
    txtStudentLastName6: '',
    txtDateOfBirth6: '',
    rdoMale6: true,
    rdoFemale6: false,
    ddlYearLevel6: '',
    ddlCompetency6: '',
    txtEmail6: '',

    txtStudentname7: '',
    txtStudentLastName7: '',
    txtDateOfBirth7: '',
    rdoMale7: true,
    rdoFemale7: false,
    ddlYearLevel7: '',
    ddlCompetency7: '',
    txtEmail7: '',

    // Login Information
    txtLoginID: '',
    txtPassword: ''
  };

  // State for form data
  const [formData, setFormData] = useState<FormData>(initialFormData);

  document.body.style.backgroundColor = "azure";

  // State for page data
  const [pageData, setPageData] = useState<PageData>({
    country: '',
    distributor4DigitCode: '',
    nowDate: '',
    states: [],
    familyBackgrounds: [],
    salesmen: [],
    leadCollectors: [],
    telemarketers: [],
    trainers: [],
    typeOfSale: [],
    competencyOptions: [],
    yearLevels: [],
    isNZ: false,
    errorMsg: '',
    showMessage: ''
  });

  // State for validation
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  // Initialize page
  useEffect(() => {
    const initialize = async () => {
      try {

        const payload = {
          school_code: sessionStorage.getItem("school_code"),
          login: sessionStorage.getItem("login"),
          position_code: sessionStorage.getItem("category"),
          office_login: sessionStorage.getItem("office_login") || ""
        };

        const response = await fetch(`${API_BASE_URL}api/check_cms_init/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success) {
          setPageData({
            ...data,

            states: (data.states || []).map((s: string) => ({
              value: s,
              name: s
            })),

            familyBackgrounds: data.familyBackgrounds || [],
            salesmen: data.salesmen || [],
            leadCollectors: data.leadCollectors || [],
            telemarketers: data.telemarketers || [],
            trainers: data.trainers || [],
            typeOfSale: data.typeOfSale || [],
            competencyOptions: data.competencyOptions || [],
            yearLevels: data.yearLevels || []
          });
          console.log("Page initialized with data:", data);

          const savedData = sessionStorage.getItem("formData");

          if (savedData) {
            const tempData = JSON.parse(savedData);
            const mappedData: Partial<FormData> = {};

            const simpleFields = [
              'txtName', 'txtEntrySurname', 'txtMotherName', 'txtMotherSurname',
              'txtAddress', 'txtState', 'txtSuburb', 'txtPostCode',
              'txtAreaCode', 'txtPhone', 'txtMobile', 'txtMobileNo2', 'txtEmail',
              'calDateOfSale', 'ddlTypeOfSale', 'txtOrderReferenceNo', 'txtSchool',
              'txtLoginID', 'txtPassword'
            ];

            simpleFields.forEach(field => {
              if (tempData[field]) {
                mappedData[field as keyof FormData] = tempData[field];
              }
            });

            if (tempData.PRIMARYCONTACT === 'F') {
              mappedData.rdoPrimaryContactFather = true;
              mappedData.rdoPrimaryContactMother = false;
            } else if (tempData.PRIMARYCONTACT === 'M') {
              mappedData.rdoPrimaryContactFather = false;
              mappedData.rdoPrimaryContactMother = true;
            }

            const dropdownFields = [
              'ddlFamilyBackground', 'ddlEntryState', 'ddlSalesman',
              'ddlLeadCollector', 'ddlTelemarketer', 'ddlTrainer'
            ];

            dropdownFields.forEach(field => {
              if (tempData[field]) {
                mappedData[field as keyof FormData] = tempData[field];
              }
            });

            if (tempData.TYPEOFPRODUCT) {
              const type = tempData.TYPEOFPRODUCT;
              mappedData.chbDongleVersion = type.includes('D');
              mappedData.chbWebVersion = type.includes('O');
            }

            for (let i = 1; i <= 7; i++) {
              const prefix = `STUDENT${i}`;
              if (tempData[prefix]) {
                const studentData = tempData[prefix].split('^');
                if (studentData.length >= 7) {
                  (mappedData as any)[`txtStudentname${i}`] = studentData[0];
                  (mappedData as any)[`txtDateOfBirth${i}`] = studentData[1];
                  (mappedData as any)[`rdoMale${i}`] = studentData[2] === 'B';
                  (mappedData as any)[`rdoFemale${i}`] = studentData[2] === 'G';
                  (mappedData as any)[`ddlYearLevel${i}`] = studentData[3];
                  (mappedData as any)[`ddlCompetency${i}`] = studentData[4];
                  (mappedData as any)[`txtStudentLastName${i}`] = studentData[5];
                  (mappedData as any)[`txtEmail${i}`] = studentData[6];
                }
              }
            }

            setFormData({ ...initialFormData, ...mappedData });
          }

        } else {
          alert(data.error || "Failed to initialize page");
        }

      } catch (error) {
        console.error("Error initializing page:", error);
        alert("Failed to initialize page. Please try again.");
      }
    };

    initialize();
    document.title = "New Sale - Check CMS";
    return () => {
      document.title = '';
    };
  }, []);

  // Set window height
  useEffect(() => {
    const setHeight = () => {
      const divHead = document.getElementById('divHead');
      if (divHead) {
        divHead.style.height = `${window.innerHeight - 30}px`;
      }
    };

    setHeight();
    window.addEventListener('resize', setHeight);
    return () => window.removeEventListener('resize', setHeight);
  }, []);

  // Handle field changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { id, value, type } = e.target as HTMLInputElement;

    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData({ ...formData, [id]: checked });
    } else if (type === 'radio') {
      const name = (e.target as HTMLInputElement).name;
      // For radio buttons, we need to update both options in the group
      if (name === 'PrimaryContact') {
        setFormData({
          ...formData,
          rdoPrimaryContactFather: id === 'rdoPrimaryContactFather',
          rdoPrimaryContactMother: id === 'rdoPrimaryContactMother'
        });
      } else if (name.startsWith('Gender')) {
        const studentNum = name.replace('Gender', '');
        setFormData({
          ...formData,
          [`rdoMale${studentNum}`]: id.startsWith('rdoMale'),
          [`rdoFemale${studentNum}`]: id.startsWith('rdoFemale')
        });
      } else {
        setFormData({ ...formData, [id]: value });
      }
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  // Handle date changes
  const handleDateChange = (date: Date, id: string) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    setFormData({ ...formData, [id]: formattedDate });
  };

  // Handle form submission (Next button)
  const handleNext = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      return;
    }

    // Save to temp session
    try {
      const tempData: { [key: string]: any } = {};

      // Map simple fields
      const simpleFields = [
        'txtName', 'txtEntrySurname', 'txtMotherName', 'txtMotherSurname',
        'txtAddress', 'txtState', 'txtSuburb', 'txtPostCode',
        'txtAreaCode', 'txtPhone', 'txtMobile', 'txtMobileNo2', 'txtEmail',
        'calDateOfSale', 'ddlTypeOfSale', 'txtOrderReferenceNo', 'txtSchool',
        'txtLoginID', 'txtPassword'
      ];

      simpleFields.forEach(field => {
        tempData[field] = formData[field as keyof FormData];
      });

      // Map radio buttons
      tempData.PRIMARYCONTACT = formData.rdoPrimaryContactFather ? 'F' : 'M';

      // Map dropdowns
      const dropdownFields = [
        'ddlFamilyBackground', 'ddlEntryState', 'ddlSalesman',
        'ddlLeadCollector', 'ddlTelemarketer', 'ddlTrainer'
      ];

      dropdownFields.forEach(field => {
        tempData[field] = formData[field as keyof FormData];
      });

      // Map checkboxes
      let typeOfProduct = '';
      if (formData.chbDongleVersion && formData.chbWebVersion) {
        typeOfProduct = 'DO';
      } else if (formData.chbDongleVersion) {
        typeOfProduct = 'D';
      } else if (formData.chbWebVersion) {
        typeOfProduct = 'O';
      }
      tempData.TYPEOFPRODUCT = typeOfProduct;

      // Map student data
      for (let i = 1; i <= 7; i++) {
        const studentData = [
          formData[`txtStudentname${i}` as keyof FormData] || '',
          formData[`txtDateOfBirth${i}` as keyof FormData] || '',
          formData[`rdoMale${i}` as keyof FormData] ? 'B' : 'G',
          formData[`ddlYearLevel${i}` as keyof FormData] || '',
          formData[`ddlCompetency${i}` as keyof FormData] || '',
          formData[`txtStudentLastName${i}` as keyof FormData] || '',
          formData[`txtEmail${i}` as keyof FormData] || ''
        ].join('^');

        if (studentData !== '^^^^^^') {
          tempData[`STUDENT${i}`] = studentData;
        }
      }

      // Save to session
      const response = await fetch(`${API_BASE_URL}api/save_temp_data/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(tempData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get state value
      const state = pageData.country === 'CHINA' ? formData.txtState : formData.ddlEntryState;

      // Navigate to next page
      navigate(`/SALES/NewSales/EL_Sales_AddPackage?StateName=${encodeURIComponent(state)}&SalesmanLogin=${encodeURIComponent(formData.ddlSalesman)}`);

    } catch (error) {
      console.error('Error saving data:', error);
      alert('Failed to save data. Please try again.');
    }
  };

  // Handle Back button
  const handleBack = async () => {
    try {
      // Clear sessions
      await fetch(`${API_BASE_URL}api/clear_sessions/`, {
        credentials: 'include'
      });

      navigate('/Sales/SalesModify/EL_SalesModify');
    } catch (error) {
      console.error('Error clearing sessions:', error);
      navigate('/Sales/SalesModify/EL_SalesModify');
    }
  };

  // Handle Cancel button
  const handleCancel = () => {
    navigate('/EL_NewSale');
  };

  // Validate form
  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};

    // Validate Father/Mother names
    if (formData.rdoPrimaryContactFather && !formData.txtName) {
      newErrors.txtName = "Please enter Father First Name";
      alert("Please enter Father First Name");
      return false;
    }

    if (formData.rdoPrimaryContactMother && !formData.txtMotherName) {
      newErrors.txtMotherName = "Please enter Mother First Name";
      alert("Please enter Mother First Name");
      return false;
    }

    if (!formData.txtEntrySurname && !formData.txtMotherSurname) {
      newErrors.txtEntrySurname = "Enter at least one parent's Surname";
      newErrors.txtMotherSurname = "Enter at least one parent's Surname";
      alert("Enter at least one parent's Surname");
      return false;
    }

    if (formData.rdoPrimaryContactFather && !formData.txtEntrySurname) {
      newErrors.txtEntrySurname = "Please enter Father's Surname as it is marked as Primary Contact";
      alert("Please enter Father's Surname as it is marked as Primary Contact");
      return false;
    }

    if (formData.rdoPrimaryContactMother && !formData.txtMotherSurname) {
      newErrors.txtMotherSurname = "Please enter Mother's Surname as it is marked as Primary Contact";
      alert("Please enter Mother's Surname as it is marked as Primary Contact");
      return false;
    }

    if (!formData.ddlFamilyBackground) {
      newErrors.ddlFamilyBackground = "Select a Family Background";
      alert("Select a Family Background");
      return false;
    }

    if (!formData.txtAddress) {
      newErrors.txtAddress = "Enter Address";
      alert("Enter Address");
      return false;
    }

    // Validate state/suburb based on country
    if (pageData.country !== 'CHINA') {
      if (!formData.ddlEntryState) {
        newErrors.ddlEntryState = "Select a State and Suburb";
        alert("Select a State and Suburb");
        return false;
      }

      if (!formData.txtEntrySuburb) {
        newErrors.txtEntrySuburb = "Select a State and Suburb";
        alert("Select a State and Suburb");
        return false;
      }
    } else {
      if (!formData.txtState) {
        newErrors.txtState = "Please enter a State.";
        alert("Please enter a State.");
        return false;
      }

      if (!formData.txtSuburb) {
        newErrors.txtSuburb = "Please enter a Suburb.";
        alert("Please enter a Suburb.");
        return false;
      }

      if (!formData.txtPostCode) {
        newErrors.txtPostCode = "Please enter a ZipCode.";
        alert("Please enter a ZipCode.");
        return false;
      }
    }

    // Validate phone/mobile
    if (!formData.txtAreaCode && !formData.txtPhone && !formData.txtMobile && !formData.txtMobileNo2) {
      alert("Please provide a valid number\n(Sample format for Home Phone: 723 1234567)\n(Sample format for Cell Phone: 4161234567 or 6471234567)");
      return false;
    } else if (formData.txtAreaCode && !formData.txtPhone) {
      alert("Please provide a valid number\n(Sample format for Home Phone: 723 1234567)");
      return false;
    } else if (!formData.txtAreaCode && formData.txtPhone) {
      alert("Please provide a valid number\n(Sample format for Home Phone: 723 1234567)");
      return false;
    }

    // Validate product type
    if (!formData.chbDongleVersion && !formData.chbWebVersion) {
      alert("Please select the type of product");
      return false;
    }

    // Validate salesman
    if (!formData.ddlSalesman) {
      newErrors.ddlSalesman = "Select a Salesman";
      alert("Select a Salesman");
      return false;
    }

    // Validate email
    if (formData.txtEmail) {
      const emails = formData.txtEmail.split(';');
      for (const email of emails) {
        if (email && !isValidEmail(email)) {
          alert("Please enter valid email ID");
          return false;
        }
      }
    }

    // Validate order reference
    if (!formData.txtOrderReferenceNo) {
      alert("Please provide an Order Reference No.");
      return false;
    }

    // Validate student details
    for (let i = 1; i <= 7; i++) {
      const hasFirstName = formData[`txtStudentname${i}` as keyof FormData];
      const hasLastName = formData[`txtStudentLastName${i}` as keyof FormData];
      const yearLevel = formData[`ddlYearLevel${i}` as keyof FormData];
      const competency = formData[`ddlCompetency${i}` as keyof FormData];

      if ((hasFirstName || hasLastName) && !yearLevel) {
        alert(`Please enter all details of student - ${i}`);
        return false;
      }

      if ((hasFirstName || hasLastName) && !competency) {
        alert(`Please enter all details of student - ${i}`);
        return false;
      }

      if (hasFirstName && !hasLastName) {
        // Auto-fill last name from parent surname
        const parentSurname = formData.txtEntrySurname || formData.txtMotherSurname;
        if (parentSurname) {
          const newFormData = { ...formData };
          (newFormData as any)[`txtStudentLastName${i}`] = parentSurname;
          setFormData(newFormData);
        }
      }

      // Validate date of birth
      const dob = (formData as any)[`txtDateOfBirth${i}`];
      if (dob && !isValidDate(dob)) {
        alert(`Please enter valid Date of Birth\n(dd/MM/yyyy format) for student ${i}`);
        return false;
      }
    }

    // Validate login
    if (!formData.txtLoginID) {
      alert("Enter LoginID");
      return false;
    } else {
      if (!isValidLogin(formData.txtLoginID)) {
        alert("Login should only contain alphabets and/or numbers.");
        return false;
      }

      // Check if login exists
      const checkLogin = async () => {
        const loginResponse = await fetch(`${API_BASE_URL}api/validate_login/?CheckLoginID=${encodeURIComponent(formData.txtLoginID)}`, {
          credentials: 'include'
        });

        if (loginResponse.ok) {
          const loginData = await loginResponse.json();
          if (loginData.exists) {
            alert("Login already exists!\nPlease choose another Login.");
            return false;
          }
        }
        return true;
      };

      if (!checkLogin()) {
        return false;
      }
    }

    // Validate password
    if (!formData.txtPassword) {
      alert("Enter Password");
      return false;
    }

    // Validate order reference
    if (formData.txtOrderReferenceNo) {
      const checkOrderRef = async () => {
        const orderRefResponse = await fetch(`${API_BASE_URL}api/validate_order_ref/?OrderRefNo=${encodeURIComponent(formData.txtOrderReferenceNo)}`, {
          credentials: 'include'
        });

        if (orderRefResponse.ok) {
          const orderRefData = await orderRefResponse.json();
          if (orderRefData.exists) {
            alert("Purchase Order No. already exists!");
            return false;
          }
        }
        return true;
      };

      if (!checkOrderRef()) {
        return false;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Helper functions
  const isValidEmail = (email: string): boolean => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const isValidDate = (date: string): boolean => {
    if (!date) return true;
    const re = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!re.test(date)) return false;

    const parts = date.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const dateObj = new Date(year, month - 1, day);
    return dateObj.getFullYear() === year &&
      dateObj.getMonth() === month - 1 &&
      dateObj.getDate() === day;
  };

  const isValidLogin = (login: string): boolean => {
    const re = /^[a-zA-Z0-9]+$/;
    return re.test(login);
  };

  // Handle suburb selection
  const handleEntrySelectSuburb = (from: string) => {
    if (!formData.ddlEntryState && pageData.country !== 'CHINA') {
      alert("Select a State");
      return;
    }

    const stateCode = pageData.country !== 'CHINA' ? formData.ddlEntryState : formData.txtState;
    const stateName = pageData.states.find(s => s.value === stateCode)?.name || stateCode;
    const country = pageData.country;

    const url = `/SALES/EL_SelectSuburb?StateName=${encodeURIComponent(stateName)}&Country=${encodeURIComponent(country)}&From=${from}`;
    // window.open(url, "ret", "top=500,left=500,width=600,height=650");
    window.location.href = url;

    // Check for return value from popup
    const checkReturn = setInterval(() => {
      // @ts-ignore - Accessing window property
      if (window['ret']) {
        // @ts-ignore
        const returnValue = window['ret'];
        // @ts-ignore
        delete window['ret'];

        if (returnValue && returnValue !== '') {
          const parts = returnValue.split('|');
          if (parts.length >= 2) {
            if (from === 's') {
              setFormData({
                ...formData,
                txtEntrySuburb: parts[0],
                txtEntryPostCode: parts[1]
              });
            } else if (from === 'z') {
              setFormData({
                ...formData,
                txtEntryPostCode: parts[1]
              });
            }
          }
        }
        clearInterval(checkReturn);
      }
    }, 100);
  };

  // Handle surname auto-fill
  const handleSurname = () => {
    if (formData.txtMotherName && !formData.txtMotherSurname) {
      setFormData({ ...formData, txtMotherSurname: formData.txtEntrySurname });
    }

    // Auto-fill student last names
    for (let i = 1; i <= 7; i++) {
      const firstNameField = `txtStudentname${i}` as keyof FormData;
      const lastNameField = `txtStudentLastName${i}` as keyof FormData;

      if ((formData as any)[firstNameField] && !(formData as any)[lastNameField]) {
        const newFormData = { ...formData };
        (newFormData as any)[lastNameField] = formData.txtEntrySurname;
        setFormData(newFormData);
      }
    }
  };

  // Handle student surname auto-fill
  const handleStudentSurname = (studentNum: string) => {
    const surname = formData.txtEntrySurname;
    if (surname) {
      const lastNameField = `txtStudentLastName${studentNum}`;
      if (!(formData as any)[lastNameField]) {
        const newFormData = { ...formData };
        (newFormData as any)[lastNameField] = surname;
        setFormData(newFormData);
      }
    }
  };

  // Handle email validation
  const handleEmailValidation = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value && !isValidEmail(value)) {
      alert("Please enter valid email ID");
      e.target.focus();
    }
  };

  // Handle date key press
  const handleDateKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.keyCode || e.charCode;
    if ((keyCode < 47 || keyCode > 57) && keyCode !== 8 && keyCode !== 46) {
      e.preventDefault();
    }
  };

  // Handle numeric key press
  const handleNumericKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.keyCode || e.charCode;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 190 && keyCode !== 37 && keyCode !== 39 && keyCode !== 16) {
      e.preventDefault();
    }
  };

  // Handle state/suburb validation
  const handleStateSuburbKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.keyCode || e.charCode;
    if ((keyCode >= 97 && keyCode <= 122) || (keyCode >= 65 && keyCode <= 90)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  };

  // Handle zip code validation
  const handleZipCodeKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.keyCode || e.charCode;
    if ((keyCode >= 97 && keyCode <= 122) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  };

  // Render the form
  return (
    <div id="divHead" style={{ overflowX: 'hidden', overflowY: 'hidden', padding: '50px 20px', height: `${window.innerHeight - 30}px`, backgroundColor:"azure" }}>
      <div style={{ width: '100%', paddingTop: '12px', paddingBottom: '12px', textAlign: 'center' }}>
        <table cellPadding={0} cellSpacing={0} width="100%">
          <tbody>
            <tr>
              <td style={{ width: '50%', verticalAlign: 'top', paddingRight: '10px' }}>
                {/* Family Details Table */}
                <table id="FamilyDetails" cellPadding={3} cellSpacing={0} style={{ width: '100%', height: '100%', border: '2px solid #AAD5FF' }}>
                  <tbody>
                    <tr>
                      <td colSpan={2} style={{ backgroundColor: '#AAD5FF', borderBottom: '2px solid #AAD5FF', fontSize: 'medium', padding: '7px', textAlign:"left" }}>
                        Family Information
                      </td>
                    </tr>

                    {/* Father/Mother Names */}
                    <tr style={{fontSize:"12px"}}>
                      <td style={{ width: '50%', paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Father First Name<span style={{ color: 'red' }}>*</span>&nbsp;&nbsp;&nbsp;
                        <input
                          type="text"
                          id="txtName"
                          className="cssTextBox"
                          style={{ width: '100px' }}
                          maxLength={50}
                          value={formData.txtName}
                          onChange={handleChange}
                        />
                      </td>
                      <td align="left">
                        Father Last Name<span style={{ color: 'red' }}>*</span>&nbsp;&nbsp;&nbsp;
                        <input
                          type="text"
                          id="txtEntrySurname"
                          className="cssTextBox"
                          style={{ width: '100px' }}
                          maxLength={50}
                          value={formData.txtEntrySurname}
                          onChange={handleChange}
                          onBlur={handleSurname}
                        />
                      </td>
                    </tr>

                    <tr style={{fontSize:"12px"}}>
                      <td style={{ width: '50%', paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Mother First Name<span style={{ color: 'red' }}>*</span>&nbsp;&nbsp;
                        <input
                          type="text"
                          id="txtMotherName"
                          className="cssTextBox"
                          style={{ width: '100px' }}
                          maxLength={50}
                          value={formData.txtMotherName}
                          onChange={handleChange}
                        />
                      </td>
                      <td align="left">
                        Mother Last Name<span style={{ color: 'red' }}>*</span>&nbsp;&nbsp;
                        <input
                          type="text"
                          id="txtMotherSurname"
                          className="cssTextBox"
                          style={{ width: '100px' }}
                          maxLength={50}
                          value={formData.txtMotherSurname}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>

                    {/* Primary Contact */}
                    <tr style={{fontSize:"12px"}}>
                      <td style={{ width: '50%', paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Primary Contact&nbsp;&nbsp;
                        <input
                          type="radio"
                          id="rdoPrimaryContactFather"
                          name="PrimaryContact"
                          checked={formData.rdoPrimaryContactFather}
                          onChange={handleChange}
                        />&nbsp;&nbsp;Father&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          id="rdoPrimaryContactMother"
                          name="PrimaryContact"
                          checked={formData.rdoPrimaryContactMother}
                          onChange={handleChange}
                        />&nbsp;Mother
                      </td>
                      <td align="left">
                        Family Background<span style={{ color: 'red' }}>*</span>&nbsp;
                        <select
                          id="ddlFamilyBackground"
                          className="cssDDL"
                          style={{ width: '120px' }}
                          value={formData.ddlFamilyBackground}
                          onChange={handleChange}
                        >
                          <option value="">-Select-</option>
                          {pageData.familyBackgrounds.map((bg, index) => (
                            <option key={index} value={bg}>{bg}</option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    {/* Address */}
                    <tr style={{fontSize:"12px"}}>
                      <td style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Address<span style={{ color: 'red' }}>*</span>
                        <span style={{ paddingLeft: '46px' }}>&nbsp;</span>
                        <input
                          type="text"
                          id="txtAddress"
                          className="cssTextBox"
                          style={{ width: '100px' }}
                          maxLength={60}
                          value={formData.txtAddress}
                          onChange={handleChange}
                        />
                      </td>
                      <td align="left">
                        State<span style={{ color: 'red' }}>*</span>
                        <span style={{ paddingLeft: '65px' }}>&nbsp;</span>
                        {pageData.country !== 'CHINA' ? (
                          <select
                            id="ddlEntryState"
                            className="cssDDL"
                            style={{ width: '107px', color: "black" }}
                            value={formData.ddlEntryState || ""}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            {pageData.states.map((state, index) => (
                              <option key={index} value={state.value}>
                                {state.name || state.value}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            id="txtState"
                            className="cssTextBox"
                            style={{ width: '100px' }}
                            maxLength={50}
                            value={formData.txtState}
                            onChange={handleChange}
                            onKeyPress={handleStateSuburbKeyPress}
                          />
                        )}
                      </td>
                    </tr>

                    {/* Suburb/Zip Code */}
                    <tr id="trCountryCode1" style={{fontSize:"12px"}}>
                      <td style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Suburb<span style={{ color: 'red' }}>*</span>
                        <span style={{ paddingLeft: '50px' }}>&nbsp;</span>
                        {pageData.country !== 'CHINA' ? (
                          <>
                            <input
                              type="text"
                              id="txtEntrySuburb"
                              className="cssTextBox"
                              style={{ width: '100px' }}
                              readOnly
                              value={formData.txtEntrySuburb}
                              onClick={() => handleEntrySelectSuburb('s')}
                            />
                            <input type="hidden" id="hidSuburb" value={formData.txtEntrySuburb} />
                          </>
                        ) : (
                          <input
                            type="text"
                            id="txtSuburb"
                            className="cssTextBox"
                            style={{ width: '100px' }}
                            maxLength={50}
                            value={formData.txtSuburb}
                            onChange={handleChange}
                            onKeyPress={handleStateSuburbKeyPress}
                          />
                        )}
                      </td>
                      <td style={{}} align="left">
                        Zip Code<span style={{ color: 'red' }}>*</span>
                        <span style={{ paddingLeft: '46px' }}>&nbsp;</span>
                        {pageData.country !== 'CHINA' ? (
                          <>
                            <input
                              type="text"
                              id="txtEntryPostCode"
                              className="cssTextBox"
                              style={{ width: '100px' }}
                              readOnly
                              value={formData.txtEntryPostCode}
                              onClick={() => handleEntrySelectSuburb('z')}
                            />
                            <input type="hidden" id="hidPostCode" value={formData.txtEntryPostCode} />
                          </>
                        ) : (
                          <input
                            type="text"
                            id="txtPostCode"
                            className="cssTextBox"
                            style={{ width: '100px' }}
                            maxLength={50}
                            value={formData.txtPostCode}
                            onChange={handleChange}
                            onKeyPress={handleZipCodeKeyPress}
                          />
                        )}
                      </td>
                    </tr>

                    {/* Phone Numbers */}
                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Home Phone<span style={{ color: 'red' }}>*</span>&nbsp;
                        <input
                          type="text"
                          id="txtAreaCode"
                          className="cssTextBox"
                          style={{ width: '50px' }}
                          maxLength={pageData.country === 'CHINA' ? 10 : 3}
                          value={formData.txtAreaCode}
                          onChange={handleChange}
                          onKeyPress={handleNumericKeyPress}
                        />
                        <input
                          type="text"
                          id="txtPhone"
                          className="cssTextBox"
                          style={{ width: '121px' }}
                          maxLength={pageData.country === 'CHINA' ? 50 : 7}
                          value={formData.txtPhone}
                          onChange={handleChange}
                          onKeyPress={handleNumericKeyPress}
                        />
                        (Either Home Phone (or) Mobile # is mandatory)
                      </td>
                    </tr>

                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Mobile #1 <span style={{ paddingLeft: '43px' }}>&nbsp;</span> &nbsp;
                        <input
                          type="text"
                          id="txtMobile"
                          className="cssTextBox"
                          style={{ width: '182px' }}
                          maxLength={pageData.country === 'CHINA' ? 50 : 10}
                          value={formData.txtMobile}
                          onChange={handleChange}
                          onKeyPress={handleNumericKeyPress}
                        />
                      </td>
                    </tr>

                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Mobile #2 <span style={{ paddingLeft: '43px' }}>&nbsp;</span> &nbsp;
                        <input
                          type="text"
                          id="txtMobileNo2"
                          className="cssTextBox"
                          style={{ width: '182px' }}
                          maxLength={pageData.country === 'CHINA' ? 50 : 10}
                          value={formData.txtMobileNo2}
                          onChange={handleChange}
                          onKeyPress={handleNumericKeyPress}
                        />
                      </td>
                    </tr>

                    {/* Email */}
                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        Email <span style={{ paddingLeft: '69px' }}>&nbsp;</span>
                        <input
                          type="text"
                          id="txtEmail"
                          className="cssTextBox"
                          style={{ width: '182px' }}
                          maxLength={200}
                          value={formData.txtEmail}
                          onChange={handleChange}
                          onBlur={handleEmailValidation}
                        />
                        <br />
                        Enter Multiple email ID with ';' separated
                      </td>
                    </tr>

                    {/* Date of Sale and Type of Sale */}
                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        <table cellPadding={0} cellSpacing={0} style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <td style={{ width: '50%', paddingBottom: '5px', paddingTop: '5px' }}>
                                Date of Sale <span style={{ paddingLeft: '32px' }}>&nbsp;</span>
                                <Flatpickr
                                  id="calDateOfSale"
                                  value={formData.calDateOfSale}
                                  onChange={([date]) => date && handleDateChange(date, 'calDateOfSale')}
                                  options={{
                                    dateFormat: "d/m/Y",
                                    allowInput: true
                                  }}
                                  style={{ width: '120px', display: 'inline-block' }}
                                />
                              </td>
                              <td id="tdTypeOfSale" style={{ width: '50%', paddingBottom: '5px' }}>
                                Type Of Sale<span style={{ color: 'red' }}>*</span>
                                <span style={{ paddingLeft: '2px' }}>&nbsp;</span>
                                <select
                                  id="ddlTypeOfSale"
                                  className="cssDDL"
                                  style={{ width: '160px' }}
                                  value={formData.ddlTypeOfSale}
                                  onChange={handleChange}
                                >
                                  {pageData.typeOfSale.map((type, index) => (
                                    <option key={index} value={type.minor}>{type.major}</option>
                                  ))}
                                </select>
                              </td>
                            </tr>

                            {/* Salesman and Lead Collector */}
                            <tr style={{fontSize:"12px"}}>
                              <td style={{ width: '50%', paddingBottom: '5px' }}>
                                Salesman<span style={{ color: 'red' }}>*</span>
                                <span style={{ paddingLeft: '37px' }}>&nbsp;</span>
                                <select
                                  id="ddlSalesman"
                                  className="cssDDL"
                                  style={{ width: '100px' }}
                                  value={formData.ddlSalesman}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Select --</option>
                                  {pageData.salesmen.map((salesman, index) => (
                                    <option key={index} value={salesman.login}>{salesman.name}</option>
                                  ))}
                                </select>
                              </td>
                              <td style={{ width: '50%', paddingBottom: '5px' }}>
                                Lead Collector
                                <span style={{ paddingLeft: '2px' }}>&nbsp;</span>
                                <select
                                  id="ddlLeadCollector"
                                  className="cssDDL"
                                  style={{ width: '100px' }}
                                  value={formData.ddlLeadCollector}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Select --</option>
                                  {pageData.leadCollectors.map((lc, index) => (
                                    <option key={index} value={lc.login}>{lc.name}</option>
                                  ))}
                                </select>
                              </td>
                            </tr>

                            {/* Telemarketer and Trainer (hidden by default) */}
                            <tr style={{ display: 'none' }}>
                              <td style={{ width: '50%', paddingBottom: '5px' }}>
                                Telemarketer
                                <span style={{ paddingLeft: '16px' }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <select
                                  id="ddlTelemarketer"
                                  className="cssDDL"
                                  style={{ width: '100px' }}
                                  value={formData.ddlTelemarketer}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Select --</option>
                                  {pageData.telemarketers.map((tm, index) => (
                                    <option key={index} value={tm.login}>{tm.name}</option>
                                  ))}
                                </select>
                              </td>
                              <td style={{ width: '50%', paddingBottom: '5px' }}>
                                Trainer
                                <span style={{ paddingLeft: '35px' }}>&nbsp;</span>
                                <select
                                  id="ddlTrainer"
                                  className="cssDDL"
                                  style={{ width: '100px' }}
                                  value={formData.ddlTrainer}
                                  onChange={handleChange}
                                >
                                  <option value="">-- Select --</option>
                                  {pageData.trainers.map((trainer, index) => (
                                    <option key={index} value={trainer.login}>{trainer.name}</option>
                                  ))}
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* Type of Product */}
                    <tr id="TypeOfProduct" style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        <table cellPadding={0} cellSpacing={0} width="100%">
                          <tbody>
                            <tr>
                              <td style={{ width: '140px' }}>
                                Type of Product<span style={{ color: 'red' }}>*</span>
                                <span style={{ paddingLeft: '2px' }}>&nbsp;</span>
                              </td>
                              <td align="left">
                                <input
                                  type="checkbox"
                                  id="chbDongleVersion"
                                  checked={formData.chbDongleVersion}
                                  onChange={handleChange}
                                />Dongle Version
                                <input
                                  type="checkbox"
                                  id="chbWebVersion"
                                  checked={formData.chbWebVersion}
                                  onChange={handleChange}
                                />Online Version
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* Order Reference and School */}
                    <tr style={{fontSize:"12px"}}>
                      <td colSpan={2} style={{ paddingLeft: '3%', paddingTop: '10px' }} align="left">
                        <table cellPadding={0} cellSpacing={0} style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <td style={{ width: '50%', paddingBottom: '5px' }}>
                                Purchase Order No.<span style={{ color: 'red' }}>*</span>
                                <span style={{ paddingLeft: '25px' }}>&nbsp;</span>
                                {pageData.distributor4DigitCode}
                                <input
                                  type="text"
                                  id="txtOrderReferenceNo"
                                  className="cssTextBox"
                                  style={{ width: '200px' }}
                                  maxLength={46}
                                  value={formData.txtOrderReferenceNo}
                                  onChange={handleChange}
                                />
                              </td>
                              <td style={{ width: '50%', padding: '0px' }}>
                                School&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <input
                                  type="text"
                                  id="txtSchool"
                                  className="cssTextBox"
                                  style={{ width: '95px' }}
                                  value={formData.txtSchool}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              {/* Student Information Table */}
              <td style={{ width: '50%', height: '100%', verticalAlign: 'top', paddingRight: '2px', backgroundColor:"azure" }}>
                <table width="100%" cellPadding={5} cellSpacing={0}>
                  <tbody style={{backgroundColor:"azure"}}>
                    <tr style={{ backgroundColor: '#AAD5FF' }}>
                      <td style={{ fontSize: 'medium', padding: '3px', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderRight: '2px solid #AAD5FF', borderBottom: '2px solid white' }} colSpan={7} align="center">
                        Student Information
                      </td>
                    </tr>

                    {/* Student Table Header */}
                    <tr style={{ backgroundColor: '#AAD5FF', fontSize:"12px" }}>
                      <td style={{ width: '22%', padding: '3px', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                        <table cellSpacing={0} cellPadding={0} style={{ padding: '0px', margin: '0px', width: '100%' }}>
                          <tbody>
                            <tr>
                              <td colSpan={2}>Student Name</td>
                            </tr>
                            <tr>
                              <td style={{ textAlign: 'center', paddingRight: '8%', width: '50%' }}>First</td>
                              <td style={{ textAlign: 'center', paddingLeft: '1px', width: '50%' }}>Last</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ width: '22%', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                        Date of<br />Birth<br />(dd/MM/yyyy)
                      </td>
                      <td style={{ width: '5%', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }} colSpan={2}>
                        <table cellSpacing={0} cellPadding={0} style={{ padding: '0px', margin: '0px', width: '100%' }}>
                          <tbody>
                            <tr>
                              <td colSpan={2}>Gender</td>
                            </tr>
                            <tr>
                              <td style={{ textAlign: 'center', paddingRight: '10%' }}>Male</td>
                              <td style={{ textAlign: 'center' }}>Female</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ width: '15%', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                        Year<br />Level
                      </td>
                      <td style={{ width: '15%', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                        Competency
                      </td>
                      <td style={{ width: '16%', borderTop: '2px solid #AAD5FF', borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF', borderRight: '2px solid #AAD5FF' }}>
                        Email
                      </td>
                    </tr>

                    {/* Student Rows */}
                    {Array.from({ length: 7 }, (_, i) => i + 1).map((studentNum) => (
                      <tr key={studentNum} id={`tr${studentNum}`} style={{ backgroundColor: 'azure' }} className="cssTableBackground">
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF', padding: '0px', paddingRight: '5px' }} align="center">
                          <table cellSpacing={0} cellPadding={0} style={{ padding: '5px', margin: '0px', width: '100%' }}>
                            <tbody>
                              <tr>
                                <td style={{ width: '50%' }}>
                                  <input
                                    type="text"
                                    id={`txtStudentname${studentNum}`}
                                    className="cssTextBox"
                                    style={{ width: '98%', borderStyle: 'solid', borderColor: '#80A0FF', borderWidth: '1px' }}
                                    maxLength={30}
                                    value={(formData as any)[`txtStudentname${studentNum}`] || ''}
                                    onChange={handleChange}
                                    onBlur={() => handleStudentSurname(studentNum.toString())}
                                  />
                                </td>
                                <td style={{ width: '50%' }}>
                                  <input
                                    type="text"
                                    id={`txtStudentLastName${studentNum}`}
                                    className="cssTextBox"
                                    style={{ width: '98%', borderStyle: 'solid', borderColor: '#80A0FF', borderWidth: '1px' }}
                                    maxLength={30}
                                    value={(formData as any)[`txtStudentLastName${studentNum}`] || ''}
                                    onChange={handleChange}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }} align="center">
                          <input
                            type="text"
                            id={`txtDateOfBirth${studentNum}`}
                            className="cssTextBox"
                            style={{ width: '82px' }}
                            maxLength={10}
                            value={(formData as any)[`txtDateOfBirth${studentNum}`] || ''}
                            onChange={handleChange}
                            onKeyPress={handleDateKeyPress}
                            placeholder="dd/MM/yyyy"
                            title="dd/MM/yyyy"
                          />
                        </td>
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                          <input
                            type="radio"
                            id={`rdoMale${studentNum}`}
                            name={`Gender${studentNum}`}
                            checked={(formData as any)[`rdoMale${studentNum}`] || false}
                            onChange={handleChange}
                          />&nbsp;
                        </td>
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }}>
                          <input
                            type="radio"
                            id={`rdoFemale${studentNum}`}
                            name={`Gender${studentNum}`}
                            checked={(formData as any)[`rdoFemale${studentNum}`] || false}
                            onChange={handleChange}
                          />&nbsp;
                        </td>
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }} align="center">
                          <select
                            id={`ddlYearLevel${studentNum}`}
                            className="cssDDL"
                            style={{ width: '90%' }}
                            value={(formData as any)[`ddlYearLevel${studentNum}`] || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            {pageData.yearLevels.map((yl, index) => (
                              <option key={index} value={yl.value}>{yl.name}</option>
                            ))}
                          </select>
                        </td>
                        <td style={{ borderLeft: '2px solid #AAD5FF', borderBottom: '2px solid #AAD5FF' }} align="center">
                          <select
                            id={`ddlCompetency${studentNum}`}
                            className="cssDDL"
                            style={{ width: '90%' }}
                            value={(formData as any)[`ddlCompetency${studentNum}`] || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            {pageData.competencyOptions.map((comp, index) => (
                              <option key={index} value={comp.minor}>{comp.major}</option>
                            ))}
                          </select>
                        </td>
                        <td style={{ border: '2px solid #AAD5FF', borderTop: 'none' }} align="center">
                          <input
                            type="text"
                            id={`txtEmail${studentNum}`}
                            className="cssTextBox"
                            style={{ width: '90%' }}
                            maxLength={50}
                            value={(formData as any)[`txtEmail${studentNum}`] || ''}
                            onChange={handleChange}
                            onBlur={handleEmailValidation}
                          />
                        </td>
                      </tr>
                    ))}

                    {/* Login Information */}
                    <tr>
                      <td colSpan={2} style={{ paddingTop: '8px' }} />
                    </tr>
                    <table id="tblLogin" style={{ border: '2px solid #AAD5FF', verticalAlign: 'bottom', width: '460%' }} cellPadding={3} cellSpacing={0}>
                      <tbody style={{width:"400px"}}>
                        <tr style={{ backgroundColor: '#AAD5FF' }}>
                          <td style={{ padding: '5px', fontSize: 'medium', borderBottom: '1px solid black' }} colSpan={2}>&nbsp;Login Information</td>
                        </tr>
                        <tr className="cssTableBackground" style={{fontSize:"12px"}}>
                          <td style={{ width: '35%', paddingLeft: '10%', paddingTop: '7px', borderTop: '2px solid #AAD5FF' }} align="left">
                            Login
                          </td>
                          <td style={{ paddingTop: '8px', borderTop: '2px solid #AAD5FF' }}>
                            <input
                              type="text"
                              id="txtLoginID"
                              className="cssTextBox"
                              style={{ width: '90%' }}
                              maxLength={20}
                              value={formData.txtLoginID}
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                        <tr className="cssTableBackground" style={{fontSize:"12px"}}>
                          <td style={{ width: '35%', paddingLeft: '10%' }} align="left">
                            Password
                          </td>
                          <td style={{ paddingBottom: '5px' }}>
                            <input
                              type="text"
                              id="txtPassword"
                              className="cssTextBox"
                              style={{ width: '90%' }}
                              maxLength={50}
                              value={formData.txtPassword}
                              onChange={handleChange}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Buttons */}
                    <div style={{ paddingTop: '26px' }} />
                    <table width="460%" style={{ border: '2px solid #AAD5FF' }} cellPadding={4} cellSpacing={0}>
                      <tbody>
                        <tr className="cssTableBackground" style={{ backgroundColor: '#FBE3ED' }}>
                          <td style={{ paddingRight: '2%', textAlign: 'center' }} colSpan={2}>
                            <button
                              id="btnCancel"
                              onClick={handleCancel}
                              style={{ width: '70px' }}
                              className="cssButton"
                            >
                              Back
                            </button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <button
                              id="btnEntryNext"
                              onClick={handleNext}
                              style={{ width: '70px' }}
                              className="cssButton"
                              onKeyDown={(e) => e.keyCode === 13 && e.preventDefault()}
                            >
                              Next
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ width: '100%', paddingTop: '12px', textAlign: 'center' }} />

      {/* Hidden fields */}
      <input type="hidden" id="hidLoginCheck" />
      <input type="hidden" id="hidDistributorLevel" />
      <input type="hidden" id="hidSearch" />
      <input type="hidden" id="hidFreshSale" />
      <input type="hidden" id="hidProspects_ID" />
      <input type="hidden" id="hidSaleType" />
      <input type="hidden" id="hidDateOfSale" />
      <input type="hidden" id="hidMultiViewIndex" value="0" />
      <input type="hidden" id="hidResultTable" />
      <input type="hidden" id="hidResultTableSub" />
      <input type="hidden" id="hidFamilyCode" />
      <input type="hidden" id="hidCommissions" />
    </div>
  );
};

export default EL_CheckCMS;